// app-user · onboarding + Home strings that the design handoff did not carry as chrome:
// guest / time-of-day greetings, the rails' empty and error copy, the area picker states,
// the location prompt outcomes and accessibility names. Spread into en.ts / bn.ts.
export const appEnHome = {
  'app.home.greetingGuest': 'Good morning',
  'app.home.greetingNoon': 'Good afternoon, {name}',
  'app.home.greetingNoonGuest': 'Good afternoon',
  'app.home.greetingEve': 'Good evening, {name}',
  'app.home.greetingEveGuest': 'Good evening',
  'app.home.chooseAreaChip': 'Choose area',
  'app.home.bookingCode': 'Booking code',
  'app.home.allAreas': 'All areas',
  'app.home.yourLocation': 'Your location',
  'app.home.areasCount': '{n} areas',
  'app.home.done': 'Done',
  'app.home.offPct': '{n}% off',
  'app.home.offFixed': '{amount} off',
  'app.home.daysLeft': '{n} days left',
  'app.home.endsToday': 'Ends today',
  'app.home.endsTomorrow': 'Ends tomorrow',
  'app.home.popularEmptyTitle': 'Nothing to show in this area yet',
  'app.home.popularEmptyBody': 'Try another area, or search for what you need.',
  'app.home.popularEmptyCta': 'Search',
  'app.home.railErrorTitle': 'Couldn’t load this',
  'app.home.railErrorBody': 'Check your connection and try again.',
  'app.home.tile.doctor': 'Doctor',
  'app.home.tile.salon': 'Salon',
  'app.home.tile.hotel': 'Hotel',
  'app.home.tile.turf': 'Turf',
  'app.home.tile.dining': 'Dining',
  'app.home.tile.events': 'Events',
  'app.home.tile.clinic': 'Clinic',
  'app.home.tile.venue': 'Venue',
  'app.home.tile.classes': 'Classes',
  'app.home.tile.gym': 'Gym',
  'app.home.tile.consult': 'Consult',
  'app.home.tile.studio': 'Studio',
  'app.home.tile.cowork': 'Cowork',
  'app.home.tile.rentals': 'Rentals',
  'app.home.saveError': 'Could not update saved places. Try again.',
  'app.home.a11y.location': 'Change area, now {area}',
  'app.home.a11y.notifications': 'Notifications',
  'app.home.a11y.notificationsUnread': 'Notifications, {n} unread',
  'app.home.a11y.search': 'Search',
  'app.home.a11y.save': 'Save {name}',
  'app.home.a11y.nextBooking': 'Your next booking: {name}',
  'app.home.a11y.areaMenu': 'Browse by area, {label}',
  'app.home.a11y.back': 'Back',
  'app.home.a11y.close': 'Close',
  'app.onboarding.area.title': 'Choose my area',
  'app.onboarding.area.noMatch': 'No area matches “{q}”',
  'app.onboarding.area.loadErrTitle': 'Couldn’t load areas',
  'app.onboarding.area.loadErrBody': 'Check your connection and try again.',
  'app.onboarding.area.saveErr': 'Saved on this phone. We couldn’t update your account — try again later.',
  'app.onboarding.location.finding': 'Finding your area…',
  'app.onboarding.location.denied': 'Location is off. You can pick your area instead.',
  'app.onboarding.location.noMatch': 'We couldn’t match your location to an area. Please pick one.',
  'app.onboarding.intro.skip': 'Tap to skip the intro',
} as const satisfies Record<string, string>;

export const appBnHome = {
  'app.home.greetingGuest': 'শুভ সকাল',
  'app.home.greetingNoon': 'শুভ দুপুর, {name}',
  'app.home.greetingNoonGuest': 'শুভ দুপুর',
  'app.home.greetingEve': 'শুভ সন্ধ্যা, {name}',
  'app.home.greetingEveGuest': 'শুভ সন্ধ্যা',
  'app.home.chooseAreaChip': 'এলাকা বেছে নিন',
  'app.home.bookingCode': 'বুকিং কোড',
  'app.home.allAreas': 'সব এলাকা',
  'app.home.yourLocation': 'আপনার অবস্থান',
  'app.home.areasCount': '{n} এলাকা',
  'app.home.done': 'হয়েছে',
  'app.home.offPct': '{n}% ছাড়',
  'app.home.offFixed': '{amount} ছাড়',
  'app.home.daysLeft': '{n} দিন বাকি',
  'app.home.endsToday': 'আজ শেষ',
  'app.home.endsTomorrow': 'কাল শেষ',
  'app.home.popularEmptyTitle': 'এই এলাকায় এখনো কিছু নেই',
  'app.home.popularEmptyBody': 'অন্য এলাকা বেছে নিন, বা যা দরকার তা খুঁজুন।',
  'app.home.popularEmptyCta': 'খুঁজুন',
  'app.home.railErrorTitle': 'লোড করা যায়নি',
  'app.home.railErrorBody': 'ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।',
  'app.home.tile.doctor': 'ডাক্তার',
  'app.home.tile.salon': 'সেলুন',
  'app.home.tile.hotel': 'হোটেল',
  'app.home.tile.turf': 'টার্ফ',
  'app.home.tile.dining': 'ডাইনিং',
  'app.home.tile.events': 'ইভেন্ট',
  'app.home.tile.clinic': 'ক্লিনিক',
  'app.home.tile.venue': 'ভেন্যু',
  'app.home.tile.classes': 'ক্লাস',
  'app.home.tile.gym': 'জিম',
  'app.home.tile.consult': 'পরামর্শ',
  'app.home.tile.studio': 'স্টুডিও',
  'app.home.tile.cowork': 'কোওয়ার্ক',
  'app.home.tile.rentals': 'ভাড়া',
  'app.home.saveError': 'সেভ করা তালিকা আপডেট করা যায়নি। আবার চেষ্টা করুন।',
  'app.home.a11y.location': 'এলাকা বদলান, এখন {area}',
  'app.home.a11y.notifications': 'নোটিফিকেশন',
  'app.home.a11y.notificationsUnread': 'নোটিফিকেশন, {n}টি না-পড়া',
  'app.home.a11y.search': 'খুঁজুন',
  'app.home.a11y.save': '{name} সেভ করুন',
  'app.home.a11y.nextBooking': 'আপনার পরবর্তী বুকিং: {name}',
  'app.home.a11y.areaMenu': 'এলাকা অনুযায়ী দেখুন, {label}',
  'app.home.a11y.back': 'পেছনে',
  'app.home.a11y.close': 'বন্ধ করুন',
  'app.onboarding.area.title': 'আমার এলাকা বেছে নিন',
  'app.onboarding.area.noMatch': '“{q}” নামে কোনো এলাকা নেই',
  'app.onboarding.area.loadErrTitle': 'এলাকা লোড হয়নি',
  'app.onboarding.area.loadErrBody': 'ইন্টারনেট সংযোগ দেখে আবার চেষ্টা করুন।',
  'app.onboarding.area.saveErr': 'এই ফোনে সেভ হয়েছে। অ্যাকাউন্টে আপডেট করা যায়নি — পরে আবার চেষ্টা করুন।',
  'app.onboarding.location.finding': 'আপনার এলাকা খোঁজা হচ্ছে…',
  'app.onboarding.location.denied': 'লোকেশন বন্ধ আছে। বরং নিজের এলাকা বেছে নিন।',
  'app.onboarding.location.noMatch': 'আপনার লোকেশনের সাথে কোনো এলাকা মেলেনি। একটি বেছে নিন।',
  'app.onboarding.intro.skip': 'ইন্ট্রো বাদ দিতে ট্যাপ করুন',
} as const satisfies Record<string, string>;
